<template>
  <router-link v-if="spec.external && (value && spec.link)"
               :to="link"
               class="form-control-static"
               style="display: inline-block">{{schemaTitle}}
  </router-link>
  <a v-else-if="spec.external && (value && typeof spec.schema.view === 'function')"
     @click="view"
     href="javascript:void(0)"
     class="form-control-static"
     style="display: inline-block">{{schemaTitle}}
  </a>
  <p v-else-if="spec.external" class="form-control-static" v-html="i18n.fr('html.nil')"></p>
  <p v-else-if="_readonly && !value" class="form-control-static" v-html="i18n.fr('html.nil')"></p>
  <el-collapse v-else :value="spec.expand ? 'a' : null">
    <el-collapse-item class="sub-schema" :class="panelClass" name="a">
      <template slot="title">{{schemaTitle}}
        <router-link v-if="value && spec.link" :to="link" style="display: block; float: right; padding: 0 15px">
          <i class="ti-new-window"></i>
        </router-link>
        <a v-else-if="value && typeof spec.schema.view === 'function'" target="_blank" @click.stop="view"
           href="javascript:void(0)" style="display: block; float: right; padding: 0 15px">
          <i class="ti-new-window"></i></a>
      </template>
      <schema-form ref="form"
                   :schema="spec.schema"
                   :model="value"
                   :$parentForm="this"
                   :rootModel="rootModel"
                   :$rootForm="$rootForm"
                   :readonly="_readonly"
                   :showActions="spec.showActions"
                   :embedded="true"></schema-form>
    </el-collapse-item>
  </el-collapse>
</template>

<script>
  import {assign, get} from 'lodash';
  import mixin from './mixin';
  import Form from '../SchemaBaseForm.vue';
  import {Collapse, CollapseItem} from 'element-ui';
  import {findKeyField} from 'src/schemas/utils';
  import i18n from 'src/i18n';

  export default {
    name: 'f-schema',
    mixins: [mixin],
    components: {
      'schema-form': Form,
      [Collapse.name]: Collapse,
      [CollapseItem.name]: CollapseItem,
    },
    computed: {
      panelClass() {
        if (typeof this.spec.class === 'function') {
          return this.spec.class.call(this, this.value, this.spec.schema, this.readonly);
        } else {
          return this.spec.class;
        }
      },
      schemaTitle() {
        if (typeof this.spec.schema.title === 'function') {
          return this.spec.schema.title.call(this, this.value, this.model);
        } else {
          return this.spec.schema.title;
        }
      },
      id() {
        if (this.value) {
          if (typeof this.value === 'string') {
            return this.value;
          } else if (this.columns) {
            let field = findKeyField(this.columns);
            return get(this.value, field.prop);
          }
        }
      },
      columns() {
        let fn = get(this, 'spec.schema.columns');
        return typeof fn === 'function'
          ? fn.call(this.$parent || this, this.value, this.spec.schema, this.readonly, false)
          : fn;
      },
      link() {
        if (this.id) {
          if (typeof this.spec.link === 'function') {
            return this.spec.link.call(this, this.id);
          } else {
            return String(this.spec.link).replace(':id', this.id);
          }
        }
      },
    },
    methods: {
      validate() {
        if (!this._readonly && this.$refs.form) {
          return this.$refs.form.validate();
        } else {
          return Promise.resolve(true);
        }
      },
      view() {
        if (this.value) {
          this.spec.schema.view.call(this.$parent || this, this.value, 0, this.spec.schema, this.columns, true);
        }
      },
    },
  };
</script>



// WEBPACK FOOTER //
// f-schema.vue?6dd1332e